import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { cn } from "../../../utils/cn";

const badgeStyles = cva("inline-flex items-center rounded-full px-2 py-1 text-sm font-medium", {
  variants: {
    variant: {
      primary: "bg-accent text-bg",
      secondary: "bg-surface text-text",
      success: "bg-success text-bg",
      danger: "bg-danger text-bg",
      info: "bg-ring text-bg",
      neutral: "bg-muted text-bg",
    },
  },
  defaultVariants: { variant: "primary" },
});

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeStyles> {}

export function Badge({ variant, className, ...props }: BadgeProps) {
  return <span className={cn(badgeStyles({ variant }), className)} {...props} />;
}

export default Badge;
